import axios from 'axios';
import { SellerCategory, SellerSubcategory } from '../types/category.types';

const BASE = process.env.REACT_APP_API_URL;

const authHeaders = (token: string) => ({ headers: { Authorization: `Bearer ${token}` } });

export interface CategoryListResponse {
    categories : SellerCategory[];
    total      : number;
    page       : number;
    pages      : number;
}

export interface SubcategoryListResponse {
    subcategories : SellerSubcategory[];
    total         : number;
    page          : number;
    pages         : number;
}

export const categoryService = {

    createCategory: (data: FormData, token: string) =>
        axios.post<{ category: SellerCategory }>(`${BASE}/seller/categories`, data, authHeaders(token)),

    getCategories: (params: Record<string, any>, token: string) =>
        axios.get<CategoryListResponse>(`${BASE}/seller/categories`, { ...authHeaders(token), params }),

    updateCategory: (id: string, data: FormData, token: string) =>
        axios.put<{ category: SellerCategory }>(`${BASE}/seller/categories/${id}`, data, authHeaders(token)),

    deleteCategory: (id: string, token: string) =>
        axios.delete(`${BASE}/seller/categories/${id}`, authHeaders(token)),

    toggleCategoryStatus: (id: string, status: 'ACTIVE' | 'INACTIVE', token: string) =>
        axios.patch(`${BASE}/seller/categories/${id}/status`, { status }, authHeaders(token)),

    createSubcategory: (data: { categoryId: string; name: string }, token: string) =>
        axios.post<{ subcategory: SellerSubcategory }>(`${BASE}/seller/subcategories`, data, authHeaders(token)),

    getSubcategories: (params: Record<string, any>, token: string) =>
        axios.get<SubcategoryListResponse>(`${BASE}/seller/subcategories`, { ...authHeaders(token), params }),

    updateSubcategory: (id: string, data: Partial<{ name: string; status: string }>, token: string) =>
        axios.put<{ subcategory: SellerSubcategory }>(`${BASE}/seller/subcategories/${id}`, data, authHeaders(token)),

    deleteSubcategory: (id: string, token: string) =>
        axios.delete(`${BASE}/seller/subcategories/${id}`, authHeaders(token)),

    toggleSubcategoryStatus: (id: string, status: 'ACTIVE' | 'INACTIVE', token: string) =>
        axios.patch(`${BASE}/seller/subcategories/${id}/status`, { status }, authHeaders(token)),
};
